const dummyData = [];
var temp = {
    title:"Loading...",
    src:"",
    link:"#",
    genre:"Genre",
    rating:0.0,
    state:"dummy"
}
for(var x = 0;x < 6;x++){
    dummyData[x] = temp;
}

export default dummyData;